import React, { useEffect, useState } from "react";
import { getNews } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import { translateNewsArray } from "../../utils/translationHelper";
import DOMPurify from 'dompurify'

function News() {
  const [news, setNews] = useState([]);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const navigate = useNavigate();

  // Получаем языковой контекст
  const { currentLanguage, languages, changeLanguage } = useLanguage();

  // Месяцы на разных языках
  const months = {
    kz: [
      "ҚАҢТАР",
      "АҚПАН",
      "НАУРЫЗ",
      "СӘУІР",
      "МАМЫР",
      "МАУСЫМ",
      "ШІЛДЕ",
      "ТАМЫЗ",
      "ҚЫРКҮЙЕК",
      "ҚАЗАН",
      "ҚАРАША",
      "ЖЕЛТОҚСАН",
    ],
    ru: [
      "ЯНВАРЬ",
      "ФЕВРАЛЬ",
      "МАРТ",
      "АПРЕЛЬ",
      "МАЙ",
      "ИЮНЬ",
      "ИЮЛЬ",
      "АВГУСТ",
      "СЕНТЯБРЬ",
      "ОКТЯБРЬ",
      "НОЯБРЬ",
      "ДЕКАБРЬ",
    ],
    en: [
      "JANUARY",
      "FEBRUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER",
    ],
  };

  // Переводы текстов
  const translations = {
    kz: {
      newsTitle: "Кітапхана жаңалықтары",
      viewAllButton: "БАРЛЫҒЫ",
    },
    ru: {
      newsTitle: "Новости библиотеки",
      viewAllButton: "ВСЕ НОВОСТИ",
    },
    en: {
      newsTitle: "Library News",
      viewAllButton: "VIEW ALL",
    },
  };

  // Получаем текущие переводы
  const t = translations[currentLanguage] || translations.kz;
  const currentMonths = months[currentLanguage] || months.kz;

  // Функция форматирования даты
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = currentMonths[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    setShowLanguageMenu(false);
  };

  useEffect(() => {
    const loadNews = async () => {
      // Получаем новости со всеми переводами
      const response = await getNews();
      if (response.news) {
        // Применяем переводы для текущего языка
        const translatedNews = translateNewsArray(response.news, currentLanguage);
        setNews(translatedNews);
      }
    };
    loadNews();
  }, [currentLanguage]); // Перезагружаем при смене языка

  const handleCardClick = (id) => {
    navigate(`/news/${id}`);
  };

  // Функция для обработки клика на Instagram ссылку
  const handleInstagramClick = (e) => {
    e.stopPropagation(); // Останавливаем всплытие события
    // Перенаправляем на Instagram
    window.open(
      "https://www.instagram.com/ulttyq_kitapkhana/?hl=ru%2F",
      "_blank"
    );
  };

  const truncate = (text, maxLength) =>
    text && text.length > maxLength ? text.slice(0, maxLength) + "..." : text || "";

  const sortedNews = [...news]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  return (
    <div className="news-section">
      <div className="news-title-line">
        <span className="line-news" />
        <h2 className="newsMain">{t.newsTitle}</h2>
        <span className="line-news" />
      </div>

      <div className="news-grid">
        {sortedNews.map((item) => (
          <div
            className="news-card"
            key={item.id}
            onClick={() => handleCardClick(item.id)}
          >
            <div className="news-image">
              <img
                src={`${process.env.REACT_APP_API_URL}${item.img_url}`}
                alt={item.title || "News image"}
              />
            </div>
            <div className="news-content">
              <div>
                <p className="news-date">{formatDate(item.date)}</p>
                <h3 className="news-title">{truncate(item.title, 30)}</h3>
              </div>
              <div className="news-footer">
                <span className="news-category">
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.description, { ALLOWED_TAGS: ['p'], ALLOWED_ATTR: [] }) || t.noDescription }} />
                </span>
                {item.instagram &&
                  <a
                    href={item.instagram}
                    target='_blank'
                    className="instagram-link"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>}
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="view-all-button" onClick={() => navigate("/news")}>
        {t.viewAllButton}
      </button>
    </div>
  );
}

export default News;